import React from "react";

export const LogoIcon = ({ size = 28, className = "" }) => (
  <img
    src="/logo.png"
    alt="Verasist Logo"
    width={size}
    height={size}
    className={`object-contain ${className}`}
  />
);

export const BRAND = {
  navy: "#2B50B8",
  coral: "#8BA8F0",
  cyan: "#4B6FD4",
};

const Logo = ({ size = 28, showText = true, className = "" }) => (
  <div className={`flex items-center gap-2 ${className}`}>
    <LogoIcon size={size} />
    {showText && (
      <span
        className="font-bold tracking-tight"
        style={{ color: "var(--fg)", fontSize: size > 26 ? 16 : 14 }}
      >
        Verasist
      </span>
    )}
  </div>
);

export default Logo;
